import { GetCulpritCustomerAttachedImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerAttachedImages/getCulpritCustomerAttachedImagesQuery.type';
import { getCulpritCustomerAttachedImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerAttachedImages/getCulpritCustomerAttachedImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCulpritCustomerAttachedImagesQueryOptions = (
  params: GetCulpritCustomerAttachedImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['CulpritCustomerAttachedImages', params],
    queryFn: () => getCulpritCustomerAttachedImagesFunction(params),
    enabled: true,
  });
};
